import { createPasswordUseCase, getAccountStatusUseCase } from '@identity/application/use-cases';
import type { ICredentialSourcePort } from '@identity/application/ports';
import type { AccountUseCases } from '@identity/composition/types';
import type { IdentityFlow, RequestAuthorizer } from '@identity/domain/types';
import type { AuthHttpClientType } from '@identity/infrastructure/api';
import { createAuthApiRepository } from '@identity/infrastructure/repositories';

/**
 * Creates the account use cases with their dependencies.
 *
 * They take the credential source of their slice because that is where the account id lives, and a
 * log without a subject cannot be tied to an account. They read only the subject from it, never the
 * token, so one use case serves both authorizers without knowing which it got.
 */
export const createAccountUseCases = (
  httpClient: AuthHttpClientType,
  credentials: ICredentialSourcePort,
  flow: IdentityFlow,
  authorizer: RequestAuthorizer,
): AccountUseCases => {
  const repository = createAuthApiRepository({ httpClient, authorizer });

  return {
    getAccountStatus: getAccountStatusUseCase(repository, credentials, flow),
    createPassword: createPasswordUseCase(repository, credentials, flow),
  };
};
